(() => {
  if (customElements.get('tile-slider')) {
    return;
  }

  class TileSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {
        perPage: 2,
        autoplay: false,
        rewind: true,
        rewindByDrag: true,
        waitForTransition: false,
        arrows: false,
        pagination: false,
        gap: '1.6rem',
        padding: { right: '3.1rem' },
        mediaQuery: 'min',
        breakpoints: {
          1023: {
            destroy: true
          }
        }
      };
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      if (!this.querySelector('.js-slider')) return;

      this.slider = new Splide(
        this.querySelector('.js-slider'),
        this.options
      ).mount();
    }
  }

  customElements.define('tile-slider', TileSlider);
})();
